import {
  DEFAULT_REFERRAL_VALUE,
  DEFAULT_REFERRAL_VALUE_NEW,
  DEFAULT_REFERRER_VALUE,
  DEFAULT_REFERRER_VALUE_NEW,
} from './Constants';

/**
 * Gets the current referral values based on the feature flag
 * @param newReferralValuesEnabled - Whether the new referral values feature is enabled
 * @returns Object containing giveValue and getValue
 */
export function getReferralValues(newReferralValuesEnabled: boolean): {
  giveValue: number;
  getValue: number;
} {
  if (newReferralValuesEnabled) {
    return {
      giveValue: DEFAULT_REFERRAL_VALUE_NEW,
      getValue: DEFAULT_REFERRER_VALUE_NEW,
    };
  }

  return {
    giveValue: DEFAULT_REFERRAL_VALUE,
    getValue: DEFAULT_REFERRER_VALUE,
  };
}

/**
 * Gets the current referral give value based on the feature flag
 * @param newReferralValuesEnabled - Whether the new referral values feature is enabled
 * @returns The give value in cents
 */
export function getReferralGiveValue(newReferralValuesEnabled: boolean): number {
  return getReferralValues(newReferralValuesEnabled).giveValue;
}

/**
 * Gets the current referral get value based on the feature flag
 * @param newReferralValuesEnabled - Whether the new referral values feature is enabled
 * @returns The get value in cents
 */
export function getReferralGetValue(newReferralValuesEnabled: boolean): number {
  return getReferralValues(newReferralValuesEnabled).getValue;
}
